<template>
  <v-container fluid class="ma-0 pa-0">
    <v-row no-gutters style="height: 128px" class="bg">
      <v-col cols="12">
        <v-row>
          <v-col cols="12" sm="8">
            <router-link to="/">
              <v-img
                height="122"
                width="389"
                :aspect-ratio="389 / 122"
                :src="require('../assets/eps_logo.png')"
              />
            </router-link>
          </v-col>
          <v-spacer />
          <v-col cols="4" class="d-none hidden-xs-and-down d-sm-block">
            <a href="https://www.facebook.com/groups/palmsociety/" target="_new">
              <v-img
                class="ml-auto ma-2 pa-2"
                height="51"
                width="170"
                :aspect-ratio="341 / 102"
                src="data:image/png;base64,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"
              />
            </a>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row no-gutters v-if="showMenu">
      <v-col cols="12">
        <div class="menu_style">
          <v-spacer />
          <v-btn
            :style="getFontSizeBasedOnScreenSize"
            :color="newsButtonColour"
            :class="epsButtonClass"
            outlined
            to="/news"
          >
            <router-link :class="epsLinkClass" to="/news">{{
              showIfScreenIsWideEnough("News")
            }}</router-link>
            <i
              :style="getFontSizeBasedOnScreenSize"
              aria-hidden="true"
              class="v-icon notranslate v-icon--center mdi mdi-newspaper theme--light"
            ></i>
          </v-btn>
          <v-btn
            :style="getFontSizeBasedOnScreenSize"
            :class="epsButtonClass"
            outlined
            to="/palminfo"
          >
            <router-link :class="epsLinkClass" to="/palminfo">
              {{ showIfScreenIsWideEnough("Palm Info") }}
            </router-link>
            <i
              aria-hidden="true"
              class="v-icon notranslate v-icon--center mdi mdi-cellphone-information theme--light"
              :style="getFontSizeBasedOnScreenSize"
            ></i>
          </v-btn>
          <v-btn
            :style="getFontSizeBasedOnScreenSize"
            :color="journalsButtonColour"
            v-if="userIsLoggedIn"
            :class="epsButtonClass"
            outlined
            to="/newsletter"
          >
            <router-link :class="epsLinkClass" to="/newsletter">
              {{ showIfScreenIsWideEnough("Journals") }}
            </router-link>
            <i
              aria-hidden="true"
              class="v-icon notranslate v-icon--center mdi mdi-newspaper-variant-outline theme--light"
              :style="getFontSizeBasedOnScreenSize"
            ></i>
          </v-btn>
          <v-btn
            :style="getFontSizeBasedOnScreenSize"
            :color="forumButtonColour"
            :class="epsButtonClass"
            outlined
            @click="clearPagingValues()"
            to="/forumboardlist"
          >
            <router-link :class="epsLinkClass" to="/forumboardlist">
              {{ showIfScreenIsWideEnough("Forums") }}
            </router-link>
            <i
              aria-hidden="true"
              class="v-icon notranslate v-icon--center mdi mdi-forum theme--light"
              :style="getFontSizeBasedOnScreenSize"
            ></i>
          </v-btn>
          <v-btn
            :style="getFontSizeBasedOnScreenSize"
            v-if="userIsLoggedIn"
            :class="epsButtonClass"
            :color="mailButtonColour"
            outlined
            to="/mail"
          >
            <router-link :class="epsLinkClass" to="/mail">
              {{ showIfScreenIsWideEnough("Mail") + showMessageCount }}
            </router-link>
            <i
              aria-hidden="true"
              class="v-icon notranslate v-icon--center mdi mdi-email-newsletter theme--light"
              :style="getFontSizeBasedOnScreenSize"
            ></i>
          </v-btn>
          <v-btn
            :style="getFontSizeBasedOnScreenSize"
            v-if="!userIsLoggedIn"
            :class="epsButtonClass"
            outlined
            to="/register"
          >
            <router-link :class="epsLinkClass" to="/register">
              {{ showIfScreenIsWideEnough("Register") }}
            </router-link>
            <i
              aria-hidden="true"
              class="v-icon notranslate v-icon--center mdi mdi-clipboard-account theme--light"
              :style="getFontSizeBasedOnScreenSize"
            ></i>
          </v-btn>
          <v-btn
            :style="getFontSizeBasedOnScreenSize"
            :color="linksButtonColour"
            :class="epsButtonClass"
            outlined
            to="/links"
          >
            <router-link :class="epsLinkClass" to="/links">
              {{ showIfScreenIsWideEnough("Links") }}
            </router-link>
            <i
              aria-hidden="true"
              class="v-icon notranslate v-icon--center mdi mdi-search-web theme--light"
              :style="getFontSizeBasedOnScreenSize"
            ></i>
          </v-btn>
          <v-btn
            :style="getFontSizeBasedOnScreenSize"
            :color="nurseriesButtonColour"
            :class="epsButtonClass"
            outlined
            to="/nurseries"
          >
            <router-link :class="epsLinkClass" to="/nurseries">
              {{ showIfScreenIsWideEnough("Nurseries") }}
            </router-link>
            <i
              aria-hidden="true"
              class="v-icon notranslate v-icon--center mdi mdi-storefront-outline theme--light"
              :style="getFontSizeBasedOnScreenSize"
            ></i>
          </v-btn>
          <v-btn
            :style="getFontSizeBasedOnScreenSize"
            v-if="!userIsLoggedIn"
            :class="epsButtonClass"
            outlined
            to="/login"
          >
            <router-link :class="epsLinkClass" to="/login">
              {{ showIfScreenIsWideEnough("Login") }}
            </router-link>
            <i
              aria-hidden="true"
              class="v-icon notranslate v-icon--center mdi mdi-login theme--light"
              :style="getFontSizeBasedOnScreenSize"
            ></i>
          </v-btn>
          <v-btn
            :style="getFontSizeBasedOnScreenSize"
            v-if="userIsLoggedIn"
            :class="epsButtonClass"
            outlined
            to="/manageprofile"
          >
            <router-link :class="epsLinkClass" to="/manageprofile">
              {{ showIfScreenIsWideEnough("Profile") }}
            </router-link>
            <i
              aria-hidden="true"
              class="v-icon notranslate v-icon--center mdi mdi-clipboard-account theme--light"
              :style="getFontSizeBasedOnScreenSize"
            ></i>
          </v-btn>
          <v-btn
            :style="getFontSizeBasedOnScreenSize"
            v-if="userIsLoggedIn && userIsOwner"
            :class="epsButtonClass"
            outlined
            to="/siteadmin"
          >
            <router-link :class="epsLinkClass" to="/siteadmin">
              {{ showIfScreenIsWideEnough("Admin") }}
            </router-link>
            <i
              aria-hidden="true"
              class="v-icon notranslate v-icon--center mdi mdi-key theme--light"
              :style="getFontSizeBasedOnScreenSize"
            ></i>
          </v-btn>
          <v-btn
            :style="getFontSizeBasedOnScreenSize"
            v-if="userIsLoggedIn"
            :class="epsButtonClass"
            outlined
            @click="logout()"
          >
            {{ showIfScreenIsWideEnough("Logout") }}
            <i
              aria-hidden="true"
              class="v-icon notranslate v-icon--center mdi mdi-logout theme--light"
              :style="getFontSizeBasedOnScreenSize"
            ></i>
          </v-btn>
          <v-spacer />
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// import SponsorLogo from "../components/SponsorLogo";
import userFunctions from "../functions/userFunctions";
import dataStore from "../functions/dataStore";

export default {
  // components: { "sponsor-logo": SponsorLogo },
  data: () => ({
    showMenu: false,
    timer: null,
  }),
  methods: {
    clearPagingValues() {
      dataStore.clearPagingValues();
    },
    logout() {
      userFunctions.logout();
      this.$router.push("/");
    },
  },
  computed: {
    epsButtonClass() {
      return "ma-1 eps_menu_button";
    },
    epsLinkClass() {
      return "ma-1 eps_menu_link";
    },
    getFontSizeBasedOnScreenSize() {
      return this.$vuetify.breakpoint.xsOnly ? "font-size: 12px" : "font-size: 14px";
    },
    showIfScreenIsWideEnough() {
      return (message) => {
        // return this.$vuetify.breakpoint.xsOnly ? "" : `${message}`;
        return message;
      };
    },
    showMessageCount() {
      return userFunctions.getUnreadMessageCount() > 0
        ? "(" + userFunctions.getUnreadMessageCount() + ")"
        : "";
    },
    userIsLoggedIn() {
      return dataStore.loggedIn;
    },
    userIsOwner() {
      return userFunctions.currentUserIsOwner();
    },
    mailButtonColour() {
      return userFunctions.getUnreadMessageCount() > 0 ? "error" : "";
    },
    newsButtonColour() {
      return userFunctions.getNewNews() ? "error" : "";
    },
    journalsButtonColour() {
      return userFunctions.getNewJournals() ? "error" : "";
    },
    linksButtonColour() {
      return userFunctions.getNewLinks() ? "error" : "";
    },
    forumButtonColour() {
      return userFunctions.getNewTopicPosts() ? "error" : "";
    },
    nurseriesButtonColour() {
      return userFunctions.getNewNurseries() ? "error" : "";
    },
  },
  mounted() {
    userFunctions.updateUnreadMessageCount();

    this.timer = setInterval(() => {
      userFunctions.updateUnreadMessageCount();
    }, 1000 * 60); //every minute for now. Some kind of back off would be better.

    this.showMenu = this.$router.history.current.name != "Holding";
  },
  watch: {
    $route() {
      userFunctions.updateUnreadMessageCount();
      this.showMenu = this.$router.history.current.name != "Holding";
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>

<style scoped>
.menu_style {
  /* white-space: nowrap; */
  /* To help visualize the fact that the container is too small */
  width: 100%;
  margin: auto;
  text-align: center;
}

.bg {
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: url("../assets/header_background.jpg") no-repeat center center;
  background-size: cover;
  background-color: transparent;
}

.eps_menu_button {
  background: #e8f0fe;
}
.eps_menu_link {
  text-decoration: none;
  color: black;
}
</style>
